// type CSVType = {
//     header: string[] | null | undefined,
//     lines: (string | number)[][],
// };

// type ExcelType = {
//     filename: string,
//     sheet: {
//         data: {
//             value: string | number,
//             type: 'string' | 'number'
//         }[][]
//     },
// };

export function toCSVString(csv /** CSVType */, sep = ',') /** -> string */ {
    const csvLines = [];

    if (csv.header) {
        csvLines.push(csv.header.join(sep));
    }

    csv.lines.forEach(csvLine => {
        csvLines.push(csvLine.join(sep));
    });

    return csvLines.join('\n');
}

export function toExcelObject(csv /** CSVType */) /** -> ExcelType */ {
    function toCell(val) {
        return {
            value: val,
            type: typeof val === 'number' ? 'number' : 'string',
        };
    }

    const excel = {
        filename: '',
        sheet: {
            data: [],
        },
    };

    if (csv.header) {
        excel.sheet.data.push(csv.header.map(toCell));
    }

    csv.lines.forEach(csvLine => {
        excel.sheet.data.push(csvLine.map(toCell));
    });

    return excel;
}
